import { createContext, useContext, useState } from 'react';
import { noop } from '../../utilities/noop';

type RedirectDetectContext = {
  isRedirect: boolean;
  setDetectRedirect: VoidFunction;
};

export const RedirectDetectProviderContext = createContext<RedirectDetectContext>({
  isRedirect: false,
  setDetectRedirect: noop,
});

export const RedirectDetectProvider: React.FC<{ isRedirect?: boolean }> = ({
  children,
  isRedirect = false,
}) => {
  const [isRedirected, setRedirect] = useState(isRedirect);
  const setDetectRedirect = () => {
    setRedirect(true);
  };

  return (
    <RedirectDetectProviderContext.Provider value={{ isRedirect: isRedirected, setDetectRedirect }}>
      {children}
    </RedirectDetectProviderContext.Provider>
  );
};

export const useRedirectDetectProvider = () => {
  return useContext(RedirectDetectProviderContext);
};
